// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import store from "./store/index";
import router from "./router";
import axios from "axios";
//引入iconfont
import "./assets/fonts/iconfont.js";
import JSEncrypt from "jsencrypt";
import i18n from "./assets/lang";

//全局注册组件
import SvgIcon from "@/components/svgicon.vue";
Vue.component("svgicon", SvgIcon);

import VueAnimateNumber from "vue-animate-number";
Vue.use(VueAnimateNumber);

import Base64 from "js-base64";
Vue.use(Base64);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import Clipboard from "v-clipboard";
Vue.use(Clipboard);
router.beforeEach((to, from, next) => {
  let url = window.location.href;
  if (url.split("?")[1]) {
    var obj = {},
      h;
    var hash = url.slice(url.indexOf("?") + 1).split("&");
    for (var i = 0; i < hash.length; i++) {
      h = hash[i].split("="); //
      obj[h[0]] = h[1];
    }
    if (obj && obj.sessionId) {
      store.commit("user/setUser", obj);
    }
  }
  if (
    !store.state.user.user.sessionId &&
    to.path != "/" &&
    to.path != "/register"
  ) {
    next({ path: "/" });
  } else {
    if (to == "/") {
      next({ path: "/index" });
    }
    next();
  }
});

/** 下面四行代码是解决ElementUi时点击同一个路由，页面报错*/
import Router from "vue-router";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
/** */

Vue.use(ElementUI);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  i18n,
  components: { App },
  template: "<App/>",
});

// 过滤器
import * as filter from "./utils/filters";
Object.keys(filter).forEach((key) => {
  Vue.filter(key, filter[key]);
});

axios.defaults.headers.common["Platform"] = "Web";
axios.defaults.headers.common["Product-ID"] = "1001";

axios.defaults.headers.common["Authorization"] =
  store.state.user.user.sessionId;

/**
 * rsa加密
 * @param {*} str  参数
 * @returns
 */
Vue.prototype.$getRsaCode = function (str) {
  // 注册方法
  // ES6 模板字符串 引用 rsa 公钥
  let pubKey = "";
  if (process.env.ENV_CONFIG === "dev") {
    //92服务器
    pubKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0FFpycy/YzbRw54YWZnN
UjgfAyoULBFCDigQxgeC06xkSHPY3NKyYPVKf55Iu9yBkyCvnKRSIz1la9PSV0te
e5hPW6VuyFVIZeoElcZ+gJEOp+bwsdafSYqdSOHHGpUZR1SYAPeqmGIo0zRWM0VP
w40A7AgREsU9zeO4cJhDl6effMPfHf6dejBROfusdJAGHS50lHUwSiqnVVVUcE5v
hdIMjfBOzdLCvecDrNXjxH43xE2Jjjmfy2pO/F83Zt1WTZk3ZV4l0Xg2IubRLm6K
+mRrSduvWF9lAdGBgsqdu4SQRitHvjeNe5f+wZwD9DxYg1d5AXRxGpucj806TJJi
twIDAQAB
-----END PUBLIC KEY-----`;
  } else {
    pubKey = `-----BEGIN PUBLIC KEY-----
      MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAu6JjBRAoo6AalNEC2w2v
      VqbSg0V33J0BIpi+IXmvXtqCy8jAslNuqJjGn/pG7+BFLGBtt9aYliqXGmLI4DmB
      Yp2SBGsEop2j2M4cDqzQ/bHidbFsPIYNr0HV4Xr1NrMyQqLyoq1muYMOeO2y4Ck9
      DTgJ3ycGhn4wwPCo3xTSJcXf3np7gWT5dxXU2HbwwhEOY9v4NPu5/Y5QNEC258Z6
      +mh/7uqhm65Fe7cIBRJHEN7+vY1R7HxuXPCPZFNFZByFaA1JFYAZgmA3/5/XI/Gl
      3miGFJn5hwW7WSY6XuIY0oJuPUm2gXATgv8Cz8URm2GINtLEuYwfZ3WETOUfDAiF
      EwIDAQAB
      -----END PUBLIC KEY-----`;
  }
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let data = encryptStr.encrypt(str); // 进行加密
  return data;
};



// WEBPACK FOOTER //
// ./src/main.js